import { getBotIcon } from "../shared/icons";
/**
 * Floating Button Component
 */
export class FloatingButton {
    constructor(position, onClick) {
        this.position = position;
        this.onClick = onClick;
        this.element = this.create();
    }
    /**
     * Create the button element
     */
    create() {
        const button = document.createElement("button");
        button.className = `me-agent-button ${this.position}`;
        button.setAttribute("aria-label", "Open chat");
        // Add bot icon
        button.innerHTML = getBotIcon({
            width: 32,
            height: 35,
            className: "me-agent-button-icon",
        });
        button.addEventListener("click", this.onClick);
        return button;
    }
    /**
     * Mount the button to the DOM
     */
    mount() {
        document.body.appendChild(this.element);
    }
    /**
     * Remove the button from the DOM
     */
    unmount() {
        this.element.remove();
    }
    /**
     * Get the button element
     */
    getElement() {
        return this.element;
    }
    /**
     * Hide the button
     */
    hide() {
        this.element.classList.add("hidden");
    }
    /**
     * Show the button
     */
    show() {
        this.element.classList.remove("hidden");
    }
}
